import { render, staticRenderFns } from "./save-wrapper.component.vue?vue&type=template&id=8ab63aa0"
import script from "./save-wrapper.component.ts?vue&type=script&lang=ts&external"
export * from "./save-wrapper.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports